import { queryOptions } from '@tanstack/react-query';

import { AuthUserData } from 'chaika-frontend-types/frontend-cms';

import { AuthApi } from '@api/AuthApi';

// Independent root: the authorized user must survive bulk user invalidation
export const authUserKeys = {
    all: ['authUser'] as const,
};

export const authUserQueryOptions = {
    current: () =>
        queryOptions({
            staleTime: Infinity,
            queryKey: authUserKeys.all,
            queryFn: (): Promise<AuthUserData> => AuthApi.getAuthorizedUser(),
        }),
};
